import { createContext, useContext } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { ListarConfigEnvelopeDestinatarioController } from "../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioControllers";
import { ListarConfigEnvelopeDocumentoController } from "../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoControllers";
import {
    ListarDocumentosProdutoController,
    ListarDocumentosUnidadeController,
} from "../../../../Controllers/Geral/Documentos/DocumentoProduto/DocumentoProdutoControllers";
import { ListarDocumentosDeContratoController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { ListarTipoRelacaoClienteController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import { ListarUsuariosSpeDoProdutoController } from "../../../../Controllers/Geral/Produtos/ProdutoSpeUsuario/ProdutoSpeUsuarioControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IConfigEnvelopeDestinatario } from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioInterfaces";
import { IConfigEnvelopeDocumento } from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";
import { IDocumentoProduto } from "../../../../Interfaces/Geral/Documentos/DocumentoProduto/DocumentoProdutoInterfaces";
import { IDocumentosTemplate } from "../../../../Interfaces/Geral/Documentos/DocumentosInterface";
import { ITipoRelacaoCliente } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import { IProdutoSpeUsuario } from "../../../../Interfaces/Geral/Produtos/ProdutoSpeUsuario/ProdutoSpeUsuarioInterfaces";
import DadosConfigEnvelope from "./DadosConfigEnvelope";
import DestinatariosConfigEnvelope from "./DestinatariosConfigEnvelope";
import DocumentosConfigEnvelope from "./DocumentosConfigEnvelope";

interface IEditarConfigDeEnvelopeProps {
    idConfigEnvelope: number;
    updateList(): void;
    idProduto: number;
}

interface IEditarConfigDeEnvelopeContext {
    destinatariosConfigEnvelope: {
        lst: IConfigEnvelopeDestinatario[];
        loading: boolean;
        update(): void;
    };
    documentosConfigEnvelope: {
        lst: IConfigEnvelopeDocumento[];
        loading: boolean;
        update(): void;
    };
    usuariosSpeDoProduto: {
        lst: IProdutoSpeUsuario[];
        loading: boolean;
        update(): void;
    };
    tipoRelacaoCliente: {
        lst: ITipoRelacaoCliente[];
        loading: boolean;
        update(): void;
    };
    documentosContrato: {
        lst: IDocumentosTemplate[];
        loading: boolean;
        update(): void;
    };
    documentosProduto: {
        lst: IDocumentoProduto[];
        loading: boolean;
        update(): void;
    };
    documentosUnidade: {
        lst: IDocumentoProduto[];
        loading: boolean;
        update(): void;
    };
    idConfigEnvelope: number;
    updateList(): void;
}

const editarConfigDeEnvelopeContext = createContext(
    {} as IEditarConfigDeEnvelopeContext
);

export default function EditarConfigDeEnvelope(
    props: IEditarConfigDeEnvelopeProps
) {
    const { idProduto } = props;

    const destinatariosConfigEnvelope = useAsyncEffect(() =>
        ListarConfigEnvelopeDestinatarioController(props.idConfigEnvelope)
    );

    const documentosConfigEnvelope = useAsyncEffect(() =>
        ListarConfigEnvelopeDocumentoController(props.idConfigEnvelope)
    );

    const usuariosSpeDoProduto = useAsyncEffect(
        () => ListarUsuariosSpeDoProdutoController(idProduto),
        [idProduto]
    );

    const tipoRelacaoCliente = useAsyncEffect(
        ListarTipoRelacaoClienteController
    );

    const documentosContrato = useAsyncEffect(
        () => ListarDocumentosDeContratoController(idProduto),
        [idProduto]
    );

    const documentosProduto = useAsyncEffect(
        () => ListarDocumentosProdutoController(idProduto),
        [idProduto]
    );

    const documentosUnidade = useAsyncEffect(
        () => ListarDocumentosUnidadeController(idProduto),
        [idProduto]
    );

    return (
        <editarConfigDeEnvelopeContext.Provider
            value={{
                destinatariosConfigEnvelope: {
                    loading: destinatariosConfigEnvelope.loading,
                    lst: destinatariosConfigEnvelope.value ?? [],
                    update: destinatariosConfigEnvelope.execute,
                },
                documentosConfigEnvelope: {
                    loading: documentosConfigEnvelope.loading,
                    lst: documentosConfigEnvelope.value ?? [],
                    update: documentosConfigEnvelope.execute,
                },
                usuariosSpeDoProduto: {
                    loading: usuariosSpeDoProduto.loading,
                    lst: usuariosSpeDoProduto.value ?? [],
                    update: usuariosSpeDoProduto.execute,
                },
                tipoRelacaoCliente: {
                    loading: tipoRelacaoCliente.loading,
                    lst: tipoRelacaoCliente.value ?? [],
                    update: tipoRelacaoCliente.execute,
                },
                documentosContrato: {
                    loading: documentosContrato.loading,
                    lst: documentosContrato.value ?? [],
                    update: documentosContrato.execute,
                },
                documentosProduto: {
                    loading: documentosProduto.loading,
                    lst: documentosProduto.value ?? [],
                    update: documentosProduto.execute,
                },
                documentosUnidade: {
                    loading: documentosUnidade.loading,
                    lst: documentosUnidade.value ?? [],
                    update: documentosUnidade.execute,
                },
                idConfigEnvelope: props.idConfigEnvelope,
                updateList: props.updateList,
            }}
        >
            <EditarConfigDeEnvelopeComponent />
        </editarConfigDeEnvelopeContext.Provider>
    );
}

export function useEditarConfigDeEnvelopeContext() {
    return useContext(editarConfigDeEnvelopeContext);
}

function EditarConfigDeEnvelopeComponent() {
    return (
        <Tabs defaultActiveKey="env">
            <Tab title="Envelope" eventKey="env">
                <div className="p-5">
                    <DadosConfigEnvelope />
                </div>
            </Tab>
            <Tab title="Destinatários" eventKey="dest">
                <div className="p-5">
                    <DestinatariosConfigEnvelope />
                </div>
            </Tab>
            <Tab title="Documentos" eventKey="docs">
                <div className="p-5">
                    <DocumentosConfigEnvelope />
                </div>
            </Tab>
        </Tabs>
    );
}
